import { render, staticRenderFns } from "./BaseListUlmoudle1.vue?vue&type=template&id=4e0eb00c&scoped=true&"
import script from "./BaseListUlmoudle1.vue?vue&type=script&lang=js&"
export * from "./BaseListUlmoudle1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0eb00c",
  null
  
)

export default component.exports